import template from './sales-by-fiscal-number.html';
import controller from './sales-by-fiscal-number.controller';
import './sales-by-fiscal-number.scss';

let SalesByFiscalNumberComponent = {
  bindings: {},
  template,
  controller
};

export default SalesByFiscalNumberComponent;



// WEBPACK FOOTER //
// ./src/app/pages/sales-by-fiscal-number/sales-by-fiscal-number.component.js